import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createHashHistory } from "history";
import { appConfig } from './components/AppConfig/variables';
const browserHistory = createHashHistory({ basename: '' });
const reactPlugin = new ReactPlugin();
// *** Add the Click Analytics plug-in. ***
/* var clickPluginInstance = new ClickAnalyticsPlugin();
   var clickPluginConfig = {
     autoCapture: true
}; */

export const instrumentationKey = appConfig.env[appConfig.current_env].instrumentationKey
const appInsights = new ApplicationInsights({
    config: {
        connectionString: instrumentationKey,
        // *** If you're adding the Click Analytics plug-in, delete the next line. ***
        enableAutoRouteTracking: true,
        disableAjaxTracking: false,
        autoTrackPageVisitTime: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        extensions: [reactPlugin],
     // *** Add the Click Analytics plug-in. ***
     // extensions: [reactPlugin, clickPluginInstance],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory }
       // *** Add the Click Analytics plug-in. ***
       // [clickPluginInstance.identifier]: clickPluginConfig,
        }
    }
});

if(instrumentationKey) {
  // appInsights.loadAppInsights();
}

export default appInsights;